export default "__VITE_ASSET__DHTUmOH4__$_?url__"